var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x9B\xB4\xE6\x8D\xA2 1",
    clipPath: "url(#clip0_1847_41317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0555 0.889248H1.38879C1.10383 0.889248 0.875854 1.11722 0.875854 1.40219V3.89563C0.875854 4.18059 1.10383 4.42281 1.40304 4.42281C1.688 4.42281 1.93022 4.19484 1.93022 3.89563V1.92937H14.0697V6.75953C14.0697 7.04449 14.2977 7.28671 14.5969 7.28671C14.8819 7.28671 15.1241 7.05874 15.1241 6.75953V1.40219C15.1241 1.11722 14.8961 0.875 14.5969 0.875H14.0555V0.889248ZM1.93022 15.109H14.5827C14.8676 15.109 15.1099 14.881 15.1099 14.5818V12.0884C15.1099 11.8034 14.8819 11.5612 14.5827 11.5612C14.2835 11.5612 14.0555 11.7892 14.0555 12.0884V14.0689H1.93022V9.23872C1.93022 8.95376 1.70225 8.71154 1.40304 8.71154C1.11807 8.71154 0.875854 8.93951 0.875854 9.23872V14.5818C0.875854 14.8668 1.10383 15.109 1.40304 15.109H1.93022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5478 6.40336C11.5478 6.27512 11.505 6.14689 11.4196 6.04715L9.08284 3.45397C8.89762 3.24025 8.55566 3.226 8.34194 3.41122C8.12821 3.6107 8.11397 3.93841 8.29919 4.15213L9.8665 5.89042H1.40304C1.11807 5.89042 0.875854 6.11839 0.875854 6.4176C0.875854 6.71682 1.10383 6.94479 1.40304 6.94479H11.0349C11.3198 6.93054 11.5478 6.68832 11.5478 6.40336ZM4.43792 9.62346C4.43792 9.7517 4.48066 9.87993 4.56615 9.97967L6.90286 12.5728C7.08809 12.7866 7.43005 12.8008 7.64377 12.6156C7.8575 12.4304 7.87174 12.0884 7.68652 11.8747L6.11921 10.1364H14.5969C14.8819 10.1364 15.1241 9.90842 15.1241 9.60921C15.1241 9.32425 14.8961 9.08203 14.5969 9.08203H4.9651C4.68014 9.09627 4.43792 9.32425 4.43792 9.62346Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1847_41317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.2efac6402970d4733a92962eb0b57f48.svg";
export { ForwardRef as ReactComponent };